import Banner from "@/components/banner";
import TitleBox from "@/components/title.vue";
import TimeLine from "@/components/timeLine.vue";
import Address from "@/components/address.vue";
export default {
  name: "about-us",
  components: {
    Banner,
    TitleBox,
    TimeLine,
    Address
  },
  data() {
    return {
      bannerImg: require("@/assets/about-us/banner.png"),
      content:
        "北京多拉智享科技有限公司是一家专注于智能自助服务 终端研发与运营。智慧屏数字传媒、大数据挖掘的移动互联网公司。依托互联网+政策，多拉自助云打印终端着重创新、与时俱进，在新的历史背景下通过文化与科技的融合，更好的服务文化创新、科技创新，将最大限度的方便大家的日常生活，致力于打造为美好生活更便捷的人工智能终端。",
      aa: "1"
    };
  },
  methods: {}
};
